<template>
  <div class="home-style login-page-root" style="margin-top: -55px;">
      <div class="row m-0">
        <div class="col-12 p-0">
            <FormLogin></FormLogin>
        </div>
      </div>
  </div>

</template>

<script>

import FormLogin from "./components/FormLogin";

export default {
  components: {
    FormLogin,
  },
  data: () => ({
      sheet: false,
      themeBackground :'/img/lp1.jpg',
      imageBackground :null,
  }),
};
</script>

<style>
.login-page-root,
.login-page-root .row,
.login-page-root .col-12 {
  width: 100%;
  max-width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
